import { useQuery } from "@tanstack/react-query";
import { notificationKeys } from "../../queryKeys";
import { getUnreadNotification } from "../../api/notification.api";

export const useUnreadNotification = () => {
  return useQuery({
    queryKey: notificationKeys.unread,
    queryFn: () => getUnreadNotification(),

    staleTime: 1000 * 30, // 30 seconds
    refetchOnWindowFocus: true,

    retry: 1,
  });
};
